import React, {useState} from "react";
import useOnClickOutside from "use-onclickoutside";
import {useDispatch, useSelector} from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";
import {useCustomLogic} from "../../../utils/customLogic";

const AdmissionList_Tab_ExtraColumns = () => {
    const [popupVisible, setPopupVisible] = useState(false);
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);
    const extraColumns = useSelector(state => state.admissionList.extraColumns);
    const dispatch = useDispatch();
    const {isCustomLogicFortius} = useCustomLogic();

    const ref = React.useRef(null);
    useOnClickOutside(ref, () => setPopupVisible(false));

    if (!state_showDevUI && !isCustomLogicFortius()) return null;

    const togglePopup = (event) => {
        setPopupVisible(!popupVisible);
        event.preventDefault();
    }

    const toggleColumn = (column) => (event) => {
        dispatch({type: actionTypes.ADMISSIONS_LIST_TOGGLE_EXTRA_COLUMN, column});
        event.preventDefault();
    }

    const anyActive = Object.values(extraColumns).some(Boolean);

    return (
        <li className={`nav-item dropdown filter`} ref={ref}>
            <a className={`nav-link ${anyActive ? 'active' : ''}`} href="#" onClick={togglePopup}><span>Extra</span> <i className="icon ico-small-down" /></a>
            <div className={`tabs-dropdown-menu dropdown-menu dropdown-menu-left${popupVisible ? ' show' : ''}`} aria-labelledby="dropdownExtraColumnsMenuButton">
                <a className="dropdown-item pointer" href="#" onClick={toggleColumn('ids')}>
                    <input type="checkbox" checked={!!extraColumns.ids} className="mr-1" readOnly />IDs
                </a>
                <a className="dropdown-item pointer" href="#" onClick={toggleColumn('ifcPaymentAmount')}>
                    <input type="checkbox" checked={!!extraColumns.ifcPaymentAmount} className="mr-1" readOnly />IFC payment amount
                </a>
            </div>
        </li>
    );
}

export default AdmissionList_Tab_ExtraColumns;
